
webpack.register(
    'components/social-share/social-share',
    function() {
        return import('components/social-share/social-share');
    },
    true
);